"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signFactory = exports.uploadSignedContentFactory = exports.useRequestStates = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
const list_source_hook_1 = require("../../utils/list-source-hook");
function useRequestStates() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'NEW', name: 'Nový' },
        { id: 'SIGNED', name: 'Podepsaný' },
        { id: 'CANCELED', name: 'Zrušený' },
        { id: 'ERROR', name: 'Chyba' },
    ]);
}
exports.useRequestStates = useRequestStates;
function uploadSignedContentFactory(url) {
    return function uploadSignedContent(id, dto) {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/${id}/upload-signed-content`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
            body: JSON.stringify(dto),
        });
    };
}
exports.uploadSignedContentFactory = uploadSignedContentFactory;
function signFactory(url) {
    return function sign(id) {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/${id}/sign`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.signFactory = signFactory;
//# sourceMappingURL=signing-api.js.map